import { Injectable } from '@angular/core';
import { CommonService } from './shareModule/services/common.service';
import { SharedService } from './shareModule/services/shared.service';

type Search = { name: string };

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private readonly SAVED_SEARCH_KEY = 'SAVED_SEARCH';
  public getSavedSearch(): Search[] {
    if (!this.sharedService.isBrowser()) {
      return [];
    }
    const savedSearch = this.commonService.getCookie(this.SAVED_SEARCH_KEY);
    return JSON.parse(savedSearch ?? '[]');
  }
  public getMatchedString(text: string): Search[] {
    const savedSearches = this.getSavedSearch();

    const rv = [];
    for (const savedSearch of savedSearches) {
      if (savedSearch.name.trim().toLowerCase().includes(text)) {
        rv.push(savedSearch);
      }
    }
    console.log('matched', { rv });
    return rv;
  }
  public removeSearch(text) {
    const savedSearches = this.getSavedSearch();
    const indexOfText = savedSearches.findIndex(
      (savedText) => savedText.name == text,
    );
    savedSearches.splice(indexOfText, 1);
    this.commonService.setCookie(
      this.SAVED_SEARCH_KEY,
      JSON.stringify(savedSearches),
    );
  }

  public addInSavedSearch(text: string) {
    const savedSearches = this.getSavedSearch();
    const existing = savedSearches.find(
      (savedText) =>
        savedText.name.trim().toLowerCase() == text.trim().toLowerCase(),
    );
    if (!existing) {
      savedSearches.push({ name: text });
      this.commonService.setCookie(
        this.SAVED_SEARCH_KEY,
        JSON.stringify(savedSearches),
      );
    }
  }

  constructor(
    private commonService: CommonService,
    private sharedService: SharedService,
  ) {}
}
